<template>
  <div>
    <b-jumbotron class="mt-4">
        <template #header>Lista {{ usersType }}</template>
        <hr class="my-4">
        <p>
            Acțiuni:
        </p>
        <b-button variant="light" :to="'/order/0/' + ordersType">Adaugă {{ ordersType }} nou</b-button>
    </b-jumbotron>
    <Vuetable
      ref="vuetable"
      :css="css.table"
      :api-url="apiUrl"
      :fields="tableFields"
      :http-fetch="fetchApiData"
      :transform="transformApiResponse"
      pagination-path="meta"
      @vuetable:pagination-data="onPaginationData"
    >
        <template slot="actions" slot-scope="props">
            <b-button-group class="mx-1">
                <b-button :to="'/user/' + props.rowData.id + '/' + props.rowData.roles" variant="warning"> Modifică</b-button>
                <b-button @click="remove(props.rowData.id)" variant="danger">Șterge</b-button>
            </b-button-group>
        </template>
    </Vuetable>
    <div class="text-center d-flex justify-content-center mt-3">
      <VuetablePagination
        ref="pagination"
        :css="css.pagination"
        @vuetable-pagination:change-page="onChangePage"
      ></VuetablePagination>
    </div>
  </div>
</template>

<script>
import config from '@/config'
import Vuetable from 'vuetable-2'
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
import CssConfig from '@/assets/other/VuetableBootstrap4Config'

export default {
  name: 'OrdersList',
  components: {
    Vuetable,
    VuetablePagination
  },
  props: {
    ordersType: {
      type: String,
      required: true
    }
  },
  mounted () {},
  data () {
    return {
      tableFields: [
        {
          name: 'id',
          title: 'ID'
        },
        {
          name: 'created_at',
          title: 'Data creării',
          formatter (value, component) {
            return component.$day(value).format('DD.MM.YYYY HH:mm')
          }
        },
        {
          name: 'actions',
          title: 'Edit'
        }
      ],
      css: CssConfig
    }
  },
  computed: {
    apiUrl () {
      return config.baseApiUrl + '/api/orders?state=' + this.ordersType
    }
  },
  methods: {
    fetchApiData (apiUrl, httpOptions) {
      return this.$axios.get(apiUrl, httpOptions)
    },
    transformApiResponse (response) {
      return response
    },
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    remove (id) {
      if (confirm('Remove?')) {
        this.$axios.delete(config.baseApiUrl + '/api/users/' + id)
          .then(() => {
            this.getData()
          })
      }
    }
  },
  watch: {
    usersType () {
      this.getData()
    }
  }
}
</script>

<style scoped>
  .table tr th,
  .table tr td {
    vertical-align: middle;
  }
</style>
